import React from 'react';

export type StatusTone =
  | 'success'   // done, completed
  | 'warning'   // pending, due-soon
  | 'info'      // informational
  | 'danger'    // overdue, error
  | 'neutral';  // generic

export interface StatusPillProps {
  tone?: StatusTone;
  /** Smaller variant for inline use within text. */
  size?: 'sm' | 'md';
  children: React.ReactNode;
}

/**
 * Use for plan status, sync status, KPI deltas — any "tag that signals state".
 * Replaces ad-hoc antd <Tag color="..."/> usage so we own the palette.
 */
export const StatusPill: React.FC<StatusPillProps> = ({
  tone = 'neutral',
  size = 'md',
  children,
}) => {
  return (
    <span className={`vc-pill vc-pill--${tone} vc-pill--${size}`}>{children}</span>
  );
};
